import { AIAssistantInterface } from "@/components/ai-assistant/AIAssistantInterface";
import { useIsMobile } from "@/hooks/use-mobile";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText, FolderPlus, Search } from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { useState } from "react";
import { cn } from "@/lib/utils";

export default function Assistant() {
  const isMobile = useIsMobile();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex-1">
      <div className="container mx-auto p-2 md:p-4 space-y-2 md:space-y-4 max-w-7xl">
        <div className="space-y-2">
          <h1 className={cn(
            "text-[#FF6634] font-bold",
            isMobile ? "text-xl" : "text-3xl",
            "transition-all duration-300"
          )}>
            AdvoKaiChat
          </h1>
          
          <Collapsible
            open={isOpen}
            onOpenChange={setIsOpen}
            className="space-y-2"
          >
            <div>
              <p className="text-muted-foreground text-sm">
                Vår avanserte RAG-teknologi kombinerer dokumentanalyse med juridisk ekspertise.
              </p>
            </div>

            <CollapsibleContent className="space-y-4">
              {!isMobile && (
                <Card className="mb-4 border-primary/20 bg-card/50 shadow-sm">
                  <CardHeader className="py-4">
                    <CardTitle className="text-primary text-lg">Intelligent juridisk assistanse</CardTitle>
                    <CardDescription className="text-muted-foreground text-sm">
                      Utforsk mulighetene med vår dokumentbaserte AI-chat
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="py-2">
                    <ul className="space-y-3">
                      <li className="flex items-start gap-3 p-2 rounded-lg hover:bg-primary/5 transition-colors">
                        <FileText className="h-5 w-5 mt-0.5 text-primary flex-shrink-0" />
                        <div>
                          <p className="font-medium text-primary text-sm">Dokumentanalyse og dialog</p>
                          <p className="text-xs text-muted-foreground">
                            Last opp juridiske dokumenter for analyse og få innsikt gjennom interaktiv dialog.
                          </p>
                        </div>
                      </li>
                      <li className="flex items-start gap-3 p-2 rounded-lg hover:bg-primary/5 transition-colors">
                        <FolderPlus className="h-5 w-5 mt-0.5 text-primary flex-shrink-0" />
                        <div>
                          <p className="font-medium text-primary text-sm">Kontekstuell forståelse</p>
                          <p className="text-xs text-muted-foreground">
                            Systemet bygger på din dokumentasjon og samtalehistorikk for presise svar.
                          </p>
                        </div>
                      </li>
                      <li className="flex items-start gap-3 p-2 rounded-lg hover:bg-primary/5 transition-colors">
                        <Search className="h-5 w-5 mt-0.5 text-primary flex-shrink-0" />
                        <div>
                          <p className="font-medium text-primary text-sm">Intelligent informasjonssøk</p>
                          <p className="text-xs text-muted-foreground">
                            Få tilgang til relevant juridisk informasjon gjennom naturlig dialog.
                          </p>
                        </div>
                      </li>
                    </ul>
                  </CardContent>
                </Card>
              )}
            </CollapsibleContent>
          </Collapsible>
        </div>

        <div className="flex-1">
          <AIAssistantInterface />
        </div>
      </div>
    </div>
  );
}